
import BackgroundGray from "@/components/helpers/BackgroundGray.vue";
import Header from "@/components/partials/Header.vue";
import Title from "@/components/style/Title.vue";
import PhotoCredits from "@/components/partials/PhotoCredits.vue";
import Breadcrumbs from "@/components/partials/Breadcrumbs.vue";
import Money from "@/components/helpers/Money.vue";
import AirportsMap from "@/components/partials/seo/AirportsMap.vue";
import ListAirlines from "@/components/partials/ListAirlines.vue";
import ListAirports from "@/components/partials/ListAirports.vue";
import Footer from "@/components/partials/Footer.vue";

export default {
  components: {
    Footer,
    ListAirports,
    ListAirlines,
    AirportsMap,
    Money,
    Breadcrumbs,
    PhotoCredits,
    Title,
    Header,
    BackgroundGray
  },
  data() {
    return {
      breadcrumbs: [],
      page: {
        image: ''
      },
      aircompanies: []
    }
  },
  nuxtI18n: {
    paths: {
      'en': '/airlines',
      'it': '/compagnie-aeree',
      'ro': '/companii-aeriene',
      'ru': '/aviakompanii',
      'pl': '/linie-lotnicze',
      'de': '/fluggesellschaften',
      'es': '/aerolineas',
      'pt': '/companhias-aereas',
      'hu': '/legitarsasagok',
      'fi': '/lentoyhtiot',
      'sv': '/flygbolag',
      'da': '/flyselskaber',
      'fr': '/compagnies-aeriennes'
    }
  },
  async fetch() {
    const page = await this.$api.contents.query({
      multiple: false,
      type: 'blank',
      code: 'aircompanies'
    }).then((res) => {
      return res.data.content;
    })
    this.page = page;

    const aircompanies = await this.$api.flightAircompany.getAll().then((res) => {
      return res.data.aircompanies;
    })
    this.aircompanies = aircompanies;

    this.breadcrumbs.push({
      text: this.$t('home.Home'),
      to: {
        name: 'index'
      }
    });

    this.breadcrumbs.push({
      text: this.$t('seo.Airlines'),
      to: {
        name: 'aircompanies'
      }
    });

    this.$store.commit('seo/setCanonical', this.localeRoute({
      name: 'aircompanies'
    }).fullPath);

    this.$store.commit('seo/setTitle', this.page.seo.title);
    this.$store.commit('seo/setDescription', this.page.seo.description);
    this.$store.commit('seo/setKeywords', this.page.seo.keywords);
    this.$store.commit('seo/setImage', this.page.image + '?format=jpg');
  }
}
